import React from "react";
import Highcharts from "highcharts";
import HC_exporting from "highcharts/modules/exporting";
import HC_exportingOff from "highcharts/modules/offline-exporting";
import moment from "moment";
import 'moment/locale/fr';

// HC_exportingOff(Highcharts);
// HC_exporting(Highcharts);
/**
 * * Catégorie 3 le type dualaxis, column, line, area
 */
export const scriptTempCharts = (data, stacking) => {
  Highcharts.dateFormats = {
    W: function (timestamp) {
      let date = new Date(timestamp),
        day = date.getUTCDay() === 0 ? 7 : date.getUTCDay(),
        dayNumber;
      date.setDate(date.getUTCDate() + 4 - day);
      dayNumber = Math.floor(
        (date.getTime() - new Date(date.getUTCFullYear(), 0, 1, -6)) / 86400000
      );
      return 1 + Math.floor(dayNumber / 7);
    },
  };
  let options = Highcharts.setOptions({
    lang: {
      months: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      weekdays: [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ],
      shortMonths: [
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Juin",
        "Juil",
        "Août",
        "Sep",
        "Oct",
        "Nov",
        "Déc",
      ],
      loading: "L'opération progresse...",
      resetZoom: "Réinitialiser le zoom",
      thousandsSep: " ",
      decimalPoint: ",",
      noData: "Aucune donnée à afficher",
    },
  });


  let xalign;
  let xrotation;
  let xaxistype = "datetime";
  let tooltipshared = true;

  let daysofweek = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche",
  ];
  let months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];
  let shortMonths = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Déc",
  ];
  ////console.log(chartId+ ', gran : '+data["granularity"]);
  if (data["avgcharttype"] && data["avgcharttype"] !== "none") {
    if (data["granularity"] === "hour") {
      if (data["avgchartperiod"] === "day") {
        xaxistype = "linear";
      } else if (data["avgchartperiod"] === "week") {
        xaxistype = "linear";
      }
    }
  } else {
    if (data["granularity"] === "hour") {
      xalign = "right";
      xrotation = -30;
    } else if (data["granularity"] === "day") {
      xalign = "right";
      xrotation = -30;
    } else if (data["granularity"] === "week") {
      xalign = "right";
      xrotation = -30;
    } else if (data["granularity"] === "month") {
      xalign = "right";
      xrotation = -30;
    } else if (data["granularity"] === "year") {
      xalign = "right";
      xrotation = -30;
    } else if (data["granularity"] === "monotone") {
      xalign = "right";
      xrotation = -30;
      xaxistype = "linear";
      tooltipshared = false;
    }
  }

  let unitLeft = "";
  if (data["yAxisTitleLeft"]) {
    unitLeft = data["yAxisTitleLeft"];
  } else {
    unitLeft = data["yAxisTitle"];
  }
  let unitRight = "";
  if (data["yAxisTitleRight"]) {
    unitRight = data["yAxisTitleRight"];
  } else {
    unitRight = data["yAxisTitle"];
  }

  let chart_params = {
    chart: {
      zoomType: "x",
      backgroundColor: "#FFFFFF",
      reflow: true,
      events: {
        selection: function (event) {
          if (event.xAxis != null) {

            if (data["granularity"] === 'hour') {
              let tick = 3600000;
              let count = (event.xAxis[0].max - event.xAxis[0].min) / tick;

            }
          }

        }
      }
    },
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          y: -20,
          //menuItems:["viewFullscreen","separator","downloadCSV","downloadXLS","downloadJPEG"]
          menuItems: [
            {
              text: "Aide sur le graphique",
              onclick: function () {
                alert("tooltip");
              },
            },
            {
              text: "Plein écran",
              onclick: function () {
                this.fullscreen.toggle(); //pour sortir le menu du chart, appeler la fonction avec script.fullscreen.toggle() par exemple
              },
            },
            {
              separator: true,
            },
            {
              text: "Télécharger en PNG",
              onclick: function () {
                this.exportChart();
              },
            },
            {
              text: "Télécharger en CSV",
              onclick: function () {
                this.downloadCSV();
              },
            },
          ],
        },
      },
      sourceHeight: 720,
      sourceWidth: 1280,
      filename: "export",
    },
    title: {
      //text: null
      text: " ",
    },
    legend: {
      itemStyle: {
        color: "#000000",
        fontWeight: "600",
        fontFamily: '"Source Sans Pro",sans-serif',
      },
      labelFormatter: function () {
        return this.name.slice(0, 40);
      },
    },
    xAxis: {
      type: xaxistype,
      tickInterval: data[" "], // one week
      labels: {
        //  format: xformat,
        align: xalign,
        rotation: xrotation,
        style: {
          color: "#000000",
        },
        formatter: function () {
          let s = "";
          if (data["avgcharttype"] && data["avgcharttype"] !== "none") {
            if (data["granularity"] === "hour") {
              if (data["avgchartperiod"] === "day") {
                s = this.value + ":00";
              } else if (data["avgchartperiod"] === "week") {
                let dayofweek = Math.floor(this.value / 24);
                let hour = this.value - dayofweek * 24;
                s = daysofweek[dayofweek] + " " + hour + ":00";
              }
            } else if (data["granularity"] === "day") {
              if (data["avgchartperiod"] === "week") {
                s = daysofweek[this.value];
              }
            } else if (data["granularity"] === "month") {
              if (data["avgchartperiod"] === "year") {
                s = shortMonths[this.value];
              }
            }
          } else {
            if (data["granularity"] === "10minutes") {
              s = moment(this.value).utc().format("DD/MM/YYYY HH:mm") + "";
            } else if (data["granularity"] === "hour") {
              s = moment(this.value).utc().format("DD/MM/YYYY HH:mm") + "";
            } else if (data["granularity"] === "day") {
              s = moment(this.value).utc().format("DD/MM/YYYY") + "";
            } else if (data["granularity"] === "month") {
              s = moment(this.value).utc().format("MMMM YYYY") + "";
            } else if (data["granularity"] === "year") {
              s = moment(this.value).utc().format("YYYY") + "";
            } else if (data["granularity"] === "monotone") {
              s = this.value + "%<br/>";
            } else {
              s = moment(this.value).utc().format("DD/MM/YYYY HH:mm") + "";
            }
          }
          return s;
        },
      },
    },
    yAxis: [
      {
        title: {
          style: {
            color: "black",
            fontWeight: "normal",
          },
          text: unitLeft,
        },
        labels: {
          style: {
            color: "#000000",
          },
        },
        //min: 0
        //max: data["yAxisExtremesMax"],
      },
      {
        title: {
          style: {
            color: "#5B87AD",
            fontWeight: "normal",
          },
          text: unitRight,
        },
        labels: {
          style: {
            color: "#5B87AD",
          },
        },
        opposite: true,
        //min: 0
        //max: 1500
      },
    ],
    tooltip: {
      shared: tooltipshared,
      formatter: function (chart) {
        moment.locale('fr');
        let points = this.points;
        let s = "";
        if (points) {
          let pointsLength = points.length;
          let index;
          if (data["avgcharttype"] && data["avgcharttype"] !== "none") {
            if (data["granularity"] === "hour") {
              if (data["avgchartperiod"] === "day") {
                s = this.x + ":00";
                s = "<b>" + this.x + ":00" + "</b><br/>";
              } else if (data["avgchartperiod"] === "week") {
                let dayofweek = Math.floor(this.x / 24);
                let hour = this.x - dayofweek * 24;
                s = daysofweek[dayofweek] + " " + hour + ":00";
                // s = dayofweek + " - " + (this.value-(dayofweek*100))+":00";
              }
            } else if (data["granularity"] === "day") {
              if (data["avgchartperiod"] === "week") {
                s = daysofweek[this.x];
              }
            } else if (data["granularity"] === "month") {
              if (data["avgchartperiod"] === "year") {
                s = months[this.x];
              }
            }
          } else {
            if (data["granularity"] === "10minutes") {
              s =
                "<b>" +
                moment(this.x).utc().format("DD/MM/YYYY HH:mm") +
                "</b><br/>";
            } else if (data["granularity"] === "hour") {
              s =
                "<b>" +
                moment(this.x).utc().format("DD/MM/YYYY HH:mm") +
                "</b><br/>";
            } else if (data["granularity"] === "day") {

              s =
                "<b>" +
                moment(this.x).utc().format("DD/MM/YYYY") +
                "</b><br/>";

            } else if (data["granularity"] === "month") {
              s = "<b>" + moment(this.x).utc().format("MMMM YYYY") + "</b><br/>";
              //s = "<b>" + Highcharts.dateFormat("%B %Y", this.x) + "</b><br/>";
            } else if (data["granularity"] === "year") {
              s = "<b>" + moment(this.x).utc().format("YYYY") + "</b><br/>";
            } else if (data["granularity"] === "monotone") {
              s = "<b>" + this.x + "%</b><br/>";
            } else {
              s =
                "<b>" +
                moment(this.x).utc().format("DD/MM/YYYY") +
                "</b><br/>";
            }
          }
          let total = 0;
          for (index = 0; index < pointsLength; index += 1) {
            let unit = "";

            if (
              points[index].series.yAxis.opposite != null &&
              points[index].series.yAxis.opposite === true
            ) {
              unit = unitRight;
            } else {
              unit = unitLeft;
            }
            s +=
              '<span style="color:' +
              points[index].series.color +
              ';">\u25CF</span> ' +
              points[index].series.name.slice(0, 40) +
              " : " +
              new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(points[index].y * 100) / 100) +
              " " +
              unit +
              "</b><br/>";
            total += points[index].y;
          }
          // if (pointsLength > 0 && points[0].total) {
          //   console.log(chart);
          //   let unit = "";
          //   if (
          //     points[0].series.yAxis.opposite != null &&
          //     points[0].series.yAxis.opposite === true
          //   ) {
          //     unit = unitRight;
          //   } else {
          //     unit = unitLeft;
          //   }
          //   s +=
          //     "<b>Total : " +
          //     Math.round(total * 100) / 100 +
          //     " " +
          //     unit +
          //     "</b><br/>";
          // }
        } else if (data["granularity"] === "monotone") {
          s =
            "<b>" +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.key * 100) / 100) +
            "% :</b> " +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.y * 100) / 100) +
            " " +
            data["yAxisTitle"];
        } else {
          s =
            this.key +
            " : " +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.y * 100) / 100) +
            " " +
            data["yAxisTitle"];
        }

        return s;
      },
    },
    plotOptions: {
      column: {
        boostThreshold: 30000,
        cropThreshold: 30000,
        pointPadding: 0.2,
        borderWidth: 0,
        stacking: stacking === "undefined" ? undefined : stacking,
        grouping: true,
        useUTC: false,
        animation: true,
      },
      area: {
        //stacking: 'normal',
        boostThreshold: 15000,
        lineColor: "#666666",
        stacking: stacking === "undefined" ? undefined : stacking,
        lineWidth: 1,
        marker: {
          enabled: false,
        },
        animation: true,
      },
      line: {
        lineWidth: 1.5,
        marker: {
          enabled: false,
        },
        animation: true,
      },
    },
    series: [],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              floating: false,
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              x: 0,
              y: 0,
            },
            yAxis: [
              {
                labels: {
                  align: "right",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                labels: {
                  align: "left",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                visible: false,
              },
            ],
          },
        },
      ],
    },
    credits: { enabled: false },
  };

  for (let i = 0; typeof data["test" + i] != "undefined"; i++) {
    if (data["test" + i][0] && data["test" + i][0].data) {
      data["test" + i][0].data.sort((a, b) => a[0] - b[0]);
    }
  }
  for (let i = 0; typeof data["test" + i] != "undefined"; i++) {
    chart_params.series.push(data["test" + i][0]);
  }

  return chart_params;
};
/**
 * * Catégorie 9 Heatmap
 */
export const scriptTempHeatMapCharts = (data, stacking) => {

  let daysofweek = [
    "Vide",
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    
  ];

  Highcharts.dateFormats.W = function (timestamp) {
    let date = new Date(timestamp),
      day = date.getUTCDay() === 0 ? 7 : date.getUTCDay(),
      dayNumber;

    date.setDate(date.getUTCDate() + 4 - day);
    dayNumber = Math.floor(
      (date.getTime() - new Date(date.getUTCFullYear(), 0, 1, -6)) / 86400000
    );

    return 1 + Math.floor(dayNumber / 7);
  };
  Highcharts.dateFormats.A = function (val) {
    if (val === 1) return "Dimanche";
    else if (val === 2) return "Lundi";
    else if (val === 3) return "Mardi";
    else if (val === 4) return "Mercredi";
    else if (val === 5) return "Jeudi";
    else if (val === 6) return "Vendredi";
    else if (val === 7) return "Samedi";
  };
  Highcharts.dateFormats.B = function (val) {
    if (val === 0) return "Janvier";
    else if (val === 1) return "Février";
    else if (val === 2) return "Mars";
    else if (val === 3) return "Avril";
    else if (val === 4) return "Mai";
    else if (val === 5) return "Juin";
    else if (val === 6) return "Juillet";
    else if (val === 7) return "Août";
    else if (val === 8) return "Septembre";
    else if (val === 9) return "Octobre";
    else if (val === 10) return "Novembre";
    else if (val === 11) return "Décembre";
  };

  Highcharts.setOptions({
    lang: {
      months: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      weekdays: [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ],
      shortMonths: [
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Juin",
        "Juil",
        "Août",
        "Sep",
        "Oct",
        "Nov",
        "Déc",
      ],
      loading: "L'opération progresse...",
      resetZoom: "Réinitialiser le zoom",
      thousandsSep: " ",
      decimalPoint: ",",
      noData: "Aucune donnée à afficher",
    },
  });

  let xAxisFormat = "";
  if (data["xAxisLabelFormat"]) {
    xAxisFormat = data["xAxisLabelFormat"];
  }

  let yAxisFormat = "";
  if (data["yAxisLabelFormat"]) {
    yAxisFormat = data["yAxisLabelFormat"];
  }

  let colorAxis;
  if (data["colorAxis"]["stops"]) {
    colorAxis = data["colorAxis"]["stops"];
  }
  let yAxisTitle = data["yAxisTitle"];

  let colsize;
  let headerFormat;
  let pointFormat;
  let chartData;

  colsize = data["test0"][0]["colsize"];
  headerFormat = data["test0"][0]["name"];
  pointFormat = data["test0"][0]["pointFormat"];
  chartData = data["test0"][0]["data"];

  let stops1;
  let stops2;
  let stops3;
  let stops4;
  stops1 = data["colorAxis"]["stops"]["0"];
  stops2 = data["colorAxis"]["stops"]["0.5"];
  stops3 = data["colorAxis"]["stops"]["0.9"];
  stops4 = data["colorAxis"]["stops"]["1"];

  console.log(data);
  let heatgranularity = data["heatgranularity"];

  let chartParams = {
    chart: {
      type: "heatmap",
      useUTC: false,
    },

    boost: {
      useGPUTranslations: true,
    },

    title: {
      text: "",
      //align: 'left',
      //x: 40
    },

    legend: {
      itemStyle: {
        color: "#000000",
        fontWeight: "600",
        fontFamily: '"Source Sans Pro",sans-serif',
      },
    },
    subtitle: {
      text: "",
      //align: 'left',
      //x: 40
    },

    xAxis: {
      type: "datetime",
      labels: {
        format: xAxisFormat, //TODO xAxisLabelFormat
      },
    },

    yAxis: {
      visible: false,
      title: {
        text: null,
        enabled: false,
      },
      labels: {
        enabled : false,
        format: yAxisFormat, //TODO yAxisLabelFormat
      },
      minPadding: 0,
      maxPadding: 0,
      startOnTick: false,
      endOnTick: false,
      //tickPositions: [0, 6, 12, 18, 24],
      tickWidth: 1,

      reversed: true,
    },

    colorAxis: {
      stops: [
        [0, stops1],
        [0.5, stops2],
        [0.9, stops3],
        [1, stops4],
      ], //TODO colorAxis.stops
      startOnTick: false,
      endOnTick: false,
      labels: {
        format: "{value}",
      },
    },
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            "separator",
            "downloadCSV",
            "downloadXLS",
            "downloadJPEG",
          ],
          //filename:'chart'+type,
        },
      },
    },
    // responsive: {
    //   rules: [
    //     {
    //       condition: {
    //         maxWidth: 500,
    //       },
    //       chartOptions: {
    //         legend: {
    //           floating: false,
    //           layout: "horizontal",
    //           align: "center",
    //           verticalAlign: "bottom",
    //           x: 0,
    //           y: 0,
    //         },
    //         yAxis: [
    //           {
    //             labels: {
    //               align: "right",
    //               x: 0,
    //               y: -6,
    //             },
    //             showLastLabel: false,
    //           },
    //           {
    //             labels: {
    //               align: "left",
    //               x: 0,
    //               y: -6,
    //             },
    //             showLastLabel: false,
    //           },
    //           {
    //             visible: false,
    //           },
    //         ],
    //       },
    //     },
    //   ],
    // },
    credits: { enabled: false },
    tooltip: {
      formatter: function (chart) {
        moment.locale('fr');
        let s = '';
        if (heatgranularity === 'hourday') {
          s =
            moment(this.point.x).utc().format("DD/MM/YYYY")
            + " " + (Math.round(this.y * 100) / 100) + ":00"
            + " : " +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.value * 100) / 100) +
            " " +
            data["yAxisTitle"];
        }
        else if (heatgranularity === 'dayweek') {
          s = daysofweek[this.y]  + ' ' +
            moment(this.point.x + ((this.y-2)*1000*60*60*24)).utc().format("DD/MM/YYYY")
            + " : " +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.value * 100) / 100) +
            " " +
            data["yAxisTitle"];
        }
        else if (heatgranularity === 'daymonth') {
          s = (Math.round(this.y * 100) / 100) + '/' +
            moment(this.point.x).utc().format("MM/YYYY")
            + " : " +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.value * 100) / 100) +
            " " +
            data["yAxisTitle"];
        }
        else if (heatgranularity === 'monthyear') {
          s = (Math.round(this.y * 100) / 100) + '/' +
            moment(this.point.x).utc().format("YYYY")
            + " : " +
            new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.value * 100) / 100) +
            " " +
            data["yAxisTitle"];
        }



        return s;
      },
    },
    series: [
      {
        dataLabels: {
          enabled: false,
          color: "#000000",
        },
        boostThreshold: 100,
        borderWidth: 0,
        nullColor: "#EFEFEF",
        colsize: colsize, // TODO series > colsize
        // tooltip: {
        //   headerFormat: headerFormat, //TODO series > name
        //   pointFormat: pointFormat, //TODO series > pointFormat
        //   valueDecimals: 2
        // },

        turboThreshold: Number.MAX_VALUE, // #3404, remove after 4.0.5 release
        data: chartData,
      },
    ],
  };

  return chartParams;
};
/**
 *  * Catégorie 10 bubble chart
 */
export const scriptTempBubbleCharts = (data, stacking) => {
  let xAxisTitle;
  let yAxisTitle;
  let xAxisUnit, yAxisUnit;
  let zAxisTitle, zAxisUnit;
  let seriesColor;
  let seriesData;

  xAxisTitle = data["xAxisTitle"];
  yAxisTitle = data["yAxisTitle"];
  xAxisUnit = data["xAxisUnit"];
  yAxisUnit = data["yAxisUnit"];
  zAxisTitle = data["zAxisTitle"];
  zAxisUnit = data["zAxisUnit"];
  seriesColor = data["test0"][0]["color"];
  seriesData = data["test0"][0]["data"];

  let chartParams = {
    chart: {
      type: "bubble",
      plotBorderWidth: 1,
      zoomType: "xy",
    },

    legend: {
      enabled: false,
    },

    title: {
      text: "",
    },

    xAxis: {
      gridLineWidth: 1,
      title: {
        text: xAxisTitle, // TODO xAxisTitle
      },
      labels: {
        format: "{value}" + " " + xAxisUnit, // TODO {value} xAxisUnit
      },
    },

    yAxis: {
      startOnTick: false,
      endOnTick: false,
      title: {
        text: yAxisTitle, // TODO yAxisTitle
      },
      labels: {
        format: "{value}" + " " + yAxisUnit, // TODO {value} yAxisUnit
      },
      maxPadding: 0.2,
    },

    tooltip: {
      useHTML: true,
      headerFormat: "<table>",
      formatter: function (chart) {
        let s = "";
        s = '<h4><b>' + this.point.name + '</b></h4>';
        s += '<b>' + xAxisTitle + '</b> : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.x * 100) / 100) + ' ' + xAxisUnit + '<br/>';
        s += '<b>' + yAxisTitle + '</b> : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.y * 100) / 100) + ' ' + yAxisUnit + '<br/>';
        s += '<b>' + zAxisTitle + '</b> : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.z * 100) / 100) + ' ' + zAxisUnit + '';
        return s;
      },
      pointFormat:
        '<tr><th colspan="2"><h4>{point.name}</h4></th></tr>' +
        "<tr><th>" +
        xAxisTitle +
        ":</th><td>{point.x}" +
        xAxisUnit +
        "</td></tr>" + // TODO xAxisTitle  xAxisUnit
        "<tr><th>" +
        yAxisTitle +
        ":</th><td>{point.y}" +
        yAxisUnit +
        "</td></tr>" + // TODO yAxisTitle  yAxisUnit
        "<tr><th>" +
        zAxisTitle +
        ":</th><td>{point.z} " +
        zAxisUnit +
        "</td></tr>", // TODO zAxisTitle  zAxisUnit
      footerFormat: "</table>",
      followPointer: true,
    },
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            "separator",
            "downloadCSV",
            "downloadXLS",
            "downloadJPEG",
          ],
        },
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: "{point.short}",
        },
      },
    },

    series: [
      {
        color: seriesColor, //TODO serie  test0 > color
        data: seriesData, //TODO serie  test0 > data
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              floating: false,
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              x: 0,
              y: 0,
            },
            yAxis: [
              {
                labels: {
                  align: "right",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                labels: {
                  align: "left",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                visible: false,
              },
            ],
          },
        },
      ],
    },
    credits: { enabled: false },
  };
  return chartParams;
};
/**
 *  * Catégorie 11 scatter chart
 */
export const scriptTempScatterCharts = (data, stacking) => {
  let xAxisTitle;
  let yAxisTitle;
  let xAxisUnit, yAxisUnit;
  let seriesColor;
  let seriesData;

  xAxisTitle = data["xAxisTitle"];
  yAxisTitle = data["yAxisTitle"];
  xAxisUnit = data["xAxisUnit"];
  yAxisUnit = data["yAxisUnit"];
  seriesColor = data["test0"][0]["color"];
  seriesData = data["test0"][0]["data"];

  let chartParams = {
    chart: {
      type: "scatter",
      zoomType: "xy",
    },
    title: {
      text: "",
    },
    xAxis: {
      title: {
        enabled: true,
        text: xAxisTitle, //todo xAxisTitle
      },
      startOnTick: true,
      endOnTick: true,
      showLastLabel: true,
    },
    yAxis: {
      title: {
        text: yAxisTitle, //todo yAxisTitle
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        }
      },
    },
    tooltip: {
      headerFormat: "",
      formatter: function (chart) {
        let s = "";
        s += '<b>' + xAxisTitle + '</b> : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.x * 100) / 100) + ' ' + xAxisUnit + '<br/>';
        s += '<b>' + yAxisTitle + '</b> : ' + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(Math.round(this.point.y * 100) / 100) + ' ' + yAxisUnit + '<br/>';

        return s;
      },
      //pointFormat: "{point.x}" + " " + xAxisUnit + " " + "{point.y}" + " " + yAxisUnit, //todo xAxisUnit, yAxisUnit
    },
    exporting: {
      enabled: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            "separator",
            "downloadCSV",
            "downloadXLS",
            "downloadJPEG",
          ],
        },
      },
    },
    series: [
      {
        //1 seule serie test0
        name: "",
        color: seriesColor, //todo serie > color

        data: seriesData, //TODO serie > data
      },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              floating: false,
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              x: 0,
              y: 0,
            },
            yAxis: [
              {
                labels: {
                  align: "right",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                labels: {
                  align: "left",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                visible: false,
              },
            ],
          },
        },
      ],
    },
    credits: { enabled: false },
  };
  return chartParams;
};
